import { render, staticRenderFns } from "./ProviderInitialization.vue?vue&type=template&id=6868d64c&scoped=true&"
import script from "./ProviderInitialization.vue?vue&type=script&lang=js&"
export * from "./ProviderInitialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868d64c",
  null
  
)

export default component.exports